var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "193",
        height: "36",
        viewBox: "0 0 193 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c(
        "g",
        {
          attrs: {
            "clip-path": "url(#clip0_3908_48)",
            transform: "scale(0.4478,0.4865)"
          }
        },
        [
          _c("path", {
            attrs: {
              d:
                "M9.21724 12.5966C3.29485 19.3315 0 28.0202 0 37C0 41.3236 0.750726 45.5641 2.21047 49.5966C3.62851 53.5045 5.67215 57.1214 8.3414 60.3225C10.9689 63.5236 14.0553 66.2674 17.6003 68.4292C18.935 69.2607 20.3113 69.9674 21.6876 70.6326C20.9786 69.9259 20.2696 69.2607 19.644 68.5539C16.1823 64.7708 13.9301 60.9461 12.9292 57.1629C12.387 55.1674 12.095 53.1304 12.0116 51.1764C11.8865 48.7652 12.095 46.3124 12.6372 43.9427C13.7633 38.9124 16.224 33.9652 20.2279 28.8101C22.6886 25.609 25.8166 22.3247 29.4868 18.9573C30.4044 18.1259 31.2385 17.2528 31.9058 16.4214C33.6158 14.3843 34.6168 12.4304 34.9087 10.5596C33.6158 9.97754 32.2812 9.47866 30.8632 9.10451C29.32 8.68878 27.5683 8.43934 25.7332 8.43934C22.3132 8.48091 16.7662 9.18765 9.21724 12.5966Z",
              fill: "#2CC4C0"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M29.6954 73.2517C32.1144 73.7506 34.6169 74 37.1193 74C41.2066 74 45.2104 73.3348 49.0475 72.0461C52.7594 70.7989 56.2211 68.9697 59.3908 66.6C62.5188 64.2719 65.2298 61.4865 67.4402 58.327C69.6924 55.1258 71.4441 51.5921 72.6119 47.8506C73.6963 44.3584 74.2385 40.7 74.2385 37C74.2385 35.8775 74.1968 34.7135 74.0717 33.591C72.9039 38.2472 70.7351 44.0258 66.6478 47.9753C65.2298 49.3472 63.6866 50.5944 62.1018 51.5921C55.5955 55.791 47.6294 57.1629 37.7032 55.7494C33.7827 55.209 29.4869 54.2112 24.8157 52.7562C21.7294 51.8 19.0601 51.4674 16.8497 51.7584C16.2658 51.8416 15.7236 51.9663 15.1814 52.091C15.3065 53.5045 15.5568 54.918 15.9321 56.373C17.8924 63.8562 25.3579 70.1753 29.6954 73.2517Z",
              fill: "#2CC4C0"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M25.6498 5.36292C27.8186 5.36292 29.8205 5.61236 31.6556 6.11124C33.6158 6.65169 35.4926 7.35843 37.2026 8.23146C40.6226 9.97753 43.5421 12.3056 46.1279 15.4236C46.8786 16.2966 47.5877 17.2528 48.255 18.2506C51.5915 23.1562 54.1357 29.4337 56.0959 37.4573C56.2627 38.2056 56.4295 38.8708 56.5964 39.536C57.1386 41.9056 57.8476 43.9011 58.7651 45.5225C59.4742 46.7697 60.3083 47.7674 61.2258 48.4742C62.3519 47.6843 63.4363 46.7697 64.4373 45.7719C66.8563 43.4438 71.1104 37.6652 72.2782 25.318C71.0687 21.7427 69.3587 18.4169 67.1482 15.3404C64.8961 12.2225 62.1851 9.52022 59.0988 7.23371C55.9708 4.94719 52.5508 3.15955 48.8806 1.91236C45.1269 0.623595 41.1648 0 37.1192 0C34.2831 0 31.4471 0.332584 28.7361 0.95618C24.9825 1.82921 21.4374 3.2427 18.1425 5.19663C17.225 5.73708 16.3074 6.3191 15.4316 6.9427C19.9776 5.65393 23.4393 5.36292 25.6498 5.36292Z",
              fill: "#2CC4C0"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M118.948 35.836V50.4281C118.114 50.4281 114.527 50.4281 113.652 50.4281V35.0461C113.652 30.5978 111.316 27.8955 107.771 27.8955C103.976 27.8955 100.222 30.0989 100.222 35.7944V50.3865H94.9252V23.3641H100.222V27.4382C101.682 24.4034 105.519 23.073 107.729 22.9067C108.772 22.8652 109.773 22.9067 110.69 23.073C114.11 23.6135 116.488 25.4011 117.781 28.3528C120.283 23.5303 124.537 22.782 127.206 22.782C134.005 22.782 137.675 27.1888 137.675 34.7966V50.4697H132.378V35.1292C132.378 30.6809 130.042 27.9371 126.164 27.9371C121.659 27.8955 118.948 31.3045 118.948 35.836Z",
              fill: "#2CC4C0"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M146.35 63.6067L152.064 49.6382L141.178 23.364H146.809L154.942 42.9449L163.074 23.364H168.705L151.855 63.6067H146.35Z",
              fill: "#2CC4C0"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M178.256 27.6045C180.049 24.5281 183.97 22.782 187.723 22.782C195.189 22.782 201.32 28.3944 201.32 37C201.32 45.5641 195.147 51.0101 187.723 51.0101C183.928 51.0101 180.049 49.5135 178.256 46.3539V63.6068H172.959V23.3641H178.256V27.6045ZM187.223 45.8551C192.102 45.8551 196.023 42.4461 196.023 37.0416C196.023 31.6371 192.144 27.9371 187.223 27.9371C182.468 27.9371 178.339 31.3045 178.339 37.0416C178.339 42.8618 182.844 45.8551 187.223 45.8551Z",
              fill: "#2CC4C0"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M211.371 50.4281H206.074V23.3641H211.371V29.4337C212.747 24.6944 215.375 22.782 218.92 22.782C220.839 22.782 222.882 23.3225 223.633 23.8214L222.799 28.7685C221.339 28.0618 219.879 27.8539 218.795 27.8539C213.54 27.8539 211.329 33.4247 211.329 40.6169V50.4281H211.371Z",
              fill: "#2CC4C0"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M225.385 36.8337C225.385 28.2697 231.849 22.8236 239.565 22.8236C247.281 22.8236 253.829 28.2697 253.829 36.8337C253.829 45.3977 247.323 51.0517 239.565 51.0517C231.808 51.0517 225.385 45.3977 225.385 36.8337ZM248.532 36.8337C248.532 31.3876 244.445 27.9786 239.565 27.9786C234.685 27.9786 230.598 31.3876 230.598 36.8337C230.598 42.3213 234.685 45.9382 239.565 45.9382C244.445 45.9382 248.532 42.3213 248.532 36.8337Z",
              fill: "#2CC4C0"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M258.583 29.6832C259 25.7337 263.171 22.782 268.009 22.782C272.597 22.782 276.976 24.9438 277.435 30.4315H272.388C272.096 28.3944 270.22 27.3551 268.134 27.3551C266.174 27.3551 264.464 28.3528 264.047 29.8079C263.797 30.6809 263.797 31.3045 264.089 31.9697C264.631 33.0921 265.882 33.6326 267.3 34.0483L271.304 35.0461C276.934 36.418 278.352 39.8685 278.352 42.945C278.352 47.9753 273.473 51.0517 267.842 51.0517C262.963 51.0517 257.916 47.9337 257.708 42.3629H262.546C262.712 43.527 263.463 44.8157 264.756 45.4393C265.924 46.1461 267.3 46.4787 269.052 46.3539C271.513 46.1876 273.139 44.7742 273.181 42.8202C273.223 40.8663 271.554 39.8685 269.594 39.4112L265.882 38.5382C260.919 37.1663 258.125 34.6719 258.583 29.6832Z",
              fill: "#2CC4C0"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M289.363 27.6045C291.156 24.5281 295.077 22.782 298.831 22.782C306.296 22.782 312.427 28.3944 312.427 37C312.427 45.5641 306.254 51.0101 298.831 51.0101C295.035 51.0101 291.156 49.5135 289.363 46.3539V63.6068H284.066V23.3641H289.363V27.6045ZM298.33 45.8551C303.21 45.8551 307.13 42.4461 307.13 37.0416C307.13 31.6371 303.252 27.9371 298.33 27.9371C293.575 27.9371 289.447 31.3045 289.447 37.0416C289.405 42.8618 293.951 45.8551 298.33 45.8551Z",
              fill: "#2CC4C0"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M343.874 38.9124H321.811C322.437 43.4438 325.982 46.2708 330.611 46.2708C333.865 46.2708 336.909 44.7742 338.411 42.1135C339.787 42.6955 341.497 43.2775 342.957 43.8595C340.621 48.5989 335.7 51.0517 330.445 51.0517C322.729 51.0517 316.556 45.4393 316.556 36.8337C316.556 28.2281 322.729 22.8236 330.445 22.8236C338.16 22.8236 343.958 28.2697 343.958 36.8337C343.916 37.4573 343.916 38.3303 343.874 38.9124ZM338.661 34.7966C338.035 30.2652 334.782 27.5629 330.403 27.5629C325.94 27.5629 322.437 30.3067 321.811 34.7966H338.661V34.7966Z",
              fill: "#2CC4C0"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M354.801 50.4281H349.505V23.3641H354.801V29.4337C356.178 24.6944 358.805 22.782 362.35 22.782C364.269 22.782 366.313 23.3225 367.063 23.8214L366.229 28.7685C364.769 28.0618 363.31 27.8539 362.225 27.8539C356.97 27.8539 354.76 33.4247 354.76 40.6169V50.4281H354.801Z",
              fill: "#2CC4C0"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M375.071 9.97753C377.115 9.97753 378.741 11.4326 378.741 13.3865C378.741 15.3405 377.115 16.7955 375.071 16.7955C373.111 16.7955 371.401 15.3405 371.401 13.3865C371.442 11.4326 373.111 9.97753 375.071 9.97753ZM377.698 23.364H372.443V50.4281H377.698V23.364Z",
              fill: "#2CC4C0"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M399.636 23.364V27.8539H393.881V50.4697H388.584V27.8539H383.704V23.364H388.584V13.1786H393.881V23.364H399.636Z",
              fill: "#2CC4C0"
            }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M408.603 63.6067L414.317 49.6382L403.432 23.364H409.062L417.195 42.9449L425.328 23.364H430.958L414.109 63.6067H408.603Z",
              fill: "#2CC4C0"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_3908_48" } }, [
          _c("rect", { attrs: { width: "431", height: "74", fill: "white" } })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }